// Eight-beat phrases, expressed in sixteenths. Each 30-second section teaches
// a repeated rhythm before adding offbeats and short fills. Built at load time.
const SONG_DIFFICULTY = [
  { start: 0, label: 'Pulso', steps: [0, 8, 16, 24], lanes: ['left', 'right'], stems: ['drums'], gap: 0.38, laneGap: 0.26, doubles: [], holdEvery: 0 },
  { start: 30, label: 'Alternancia', steps: [0, 4, 8, 12, 14, 16, 20, 24, 28, 30], lanes: ['left', 'right'], stems: ['drums', 'bass'], gap: 0.18, laneGap: 0.24, doubles: [24], doubleEvery: 2, holdStep: 16, holdEvery: 3, holdBeats: 2 },
  { start: 60, label: 'Contratiempos', steps: Array.from({ length: 16 }, (_, i) => i * 2), lanes: ['left', 'right'], stems: ['drums', 'bass', 'music'], gap: 0.12, laneGap: 0.2, doubles: [0, 24], doubleEvery: 2, holdStep: 8, holdEvery: 2, holdBeats: 2 },
  { start: 90, label: 'Síncopas', steps: Array.from({ length: 32 }, (_, i) => i).filter(i => i % 4 !== 3), lanes: ['left', 'right', 'right', 'left'], stems: ['drums', 'bass', 'music'], gap: 0.09, laneGap: 0.16, doubles: [0, 16], doubleEvery: 1, holdStep: 8, holdEvery: 3, holdBeats: 2 },
  { start: 120, label: 'Combinaciones', steps: Array.from({ length: 32 }, (_, i) => i).filter(i => i % 8 !== 7), lanes: ['left', 'right'], stems: ['drums', 'bass', 'music'], gap: 0.075, laneGap: 0.13, doubles: [0, 12, 24], doubleEvery: 1, holdStep: 8, holdEvery: 3, holdBeats: 1 },
  { start: 150, label: 'Final', steps: Array.from({ length: 32 }, (_, i) => i), lanes: ['left', 'right'], stems: ['drums', 'bass', 'music'], gap: 0.06, laneGap: 0.105, doubles: [0, 8, 16, 24], doubleEvery: 1, holdStep: 4, holdEvery: 3, holdBeats: 2 },
];

const getSongDifficulty = time => SONG_DIFFICULTY.reduce((current, phase) => time >= phase.start ? phase : current, SONG_DIFFICULTY[0]);
// Rotate musical slots by whole beats within the same eight-beat phrase.
// Every slot still has to match an actual recorded attack in buildSongChart.
const SONG_VARIANTS = [
  { beatOffset: 0, lanes: null },
  { beatOffset: 2, lanes: ['right', 'left'] },
  { beatOffset: 4, lanes: ['left', 'left', 'right', 'right'] },
  { beatOffset: 6, lanes: ['right', 'left', 'left', 'right'] },
];
const getSongVariant = seed => (seed >>> 0) % SONG_VARIANTS.length;
const VARIANT_PHASES = SONG_VARIANTS.map((variant, index) => SONG_DIFFICULTY.map(phase => {
  if (index === 0) return phase;
  const shift = step => (step + variant.beatOffset * 4) % 32;
  return {
    ...phase,
    steps: phase.steps.map(shift).sort((a, b) => a - b),
    lanes: phase.start === 0 ? ['right', 'left'] : variant.lanes,
    doubles: phase.doubles.map(shift),
    holdStep: phase.holdStep == null ? undefined : shift(phase.holdStep),
  };
}));
const getVariantDifficulty = (time, seed) => {
  const phases = VARIANT_PHASES[getSongVariant(seed)];
  return phases.reduce((current, phase) => time >= phase.start ? phase : current, phases[0]);
};
module.exports = { SONG_DIFFICULTY, SONG_VARIANTS, getSongDifficulty, getSongVariant, getVariantDifficulty };
